export const PROVINCIAS_ARGENTINA = [
  'Buenos Aires',
  'Ciudad Autónoma de Buenos Aires',
  'Catamarca',
  'Chaco',
  'Chubut',
  'Córdoba',
  'Corrientes',
  'Entre Ríos',
  'Formosa',
  'Jujuy',
  'La Pampa',
  'La Rioja',
  'Mendoza',
  'Misiones',
  'Neuquén',
  'Río Negro',
  'Salta',
  'San Juan',
  'San Luis',
  'Santa Cruz',
  'Santa Fe',
  'Santiago del Estero',
  'Tierra del Fuego',
  'Tucumán',
];

export const CIUDADES_POR_PROVINCIA: Record<string, string[]> = {
  'Buenos Aires': [
    'La Plata', 'Mar del Plata', 'Bahía Blanca', 'Tandil', 'Olavarría',
    'Junín', 'Pergamino', 'San Nicolás de los Arroyos', 'Zárate', 'Campana',
    'Luján', 'Mercedes', 'Chivilcoy', 'Necochea', 'Tres Arroyos',
    'Azul', 'Bolívar', 'Dolores', 'Chascomús', 'Lobos',
    'Avellaneda', 'Quilmes', 'Lanús', 'Lomas de Zamora', 'Banfield',
    'Adrogué', 'Temperley', 'Berazategui', 'Florencio Varela', 'Almirante Brown',
    'San Martín', 'Vicente López', 'San Isidro', 'Tigre', 'Pilar',
    'Escobar', 'San Fernando', 'Morón', 'Ituzaingó', 'Merlo',
    'Moreno', 'José C. Paz', 'San Miguel', 'Malvinas Argentinas', 'Hurlingham',
    'Tres de Febrero', 'La Matanza', 'Esteban Echeverría', 'Ezeiza', 'Presidente Perón',
    'San Vicente', 'Cañuelas', 'General Rodríguez', 'Marcos Paz', 'Brandsen',
    'Coronel Suárez', 'Trenque Lauquen', 'Pehuajó', '9 de Julio', 'Bragado',
    'Lincoln', 'General Villegas', 'General Pinto', 'Rojas', 'Colón',
    'Salto', 'Arrecifes', 'Baradero', 'San Pedro', 'Ramallo',
    'Ensenada', 'Berisso', 'Magdalena', 'Punta Indio', 'General Belgrano',
    'Las Flores', 'Saladillo', 'Roque Pérez', '25 de Mayo', 'Navarro',
    'Lobería', 'Balcarce', 'General Pueyrredón', 'General Alvarado', 'Miramar',
    'Pinamar', 'Villa Gesell', 'Mar de Ajó', 'San Clemente del Tuyú', 'Santa Teresita',
    'Monte Hermoso', 'Coronel Rosales', 'Punta Alta', 'Tornquist', 'Sierra de la Ventana',
  ],
  'Ciudad Autónoma de Buenos Aires': [
    'CABA', 'Buenos Aires', 'Palermo', 'Belgrano', 'Recoleta',
    'Caballito', 'Flores', 'Villa Urquiza', 'Almagro', 'Balvanera',
    'San Telmo', 'La Boca', 'Barracas', 'Constitución', 'Monserrat',
    'San Nicolás', 'Retiro', 'Puerto Madero', 'Núñez', 'Colegiales',
    'Villa Crespo', 'Chacarita', 'Paternal', 'Villa del Parque', 'Devoto',
    'Villa Pueyrredón', 'Agronomía', 'Parque Chas', 'Saavedra', 'Coghlan',
    'Villa Ortúzar', 'Villa Luro', 'Liniers', 'Mataderos', 'Parque Avellaneda',
    'Parque Chacabuco', 'Boedo', 'Pompeya', 'Soldati', 'Villa Lugano',
    'Villa Riachuelo', 'Versalles', 'Monte Castro', 'Vélez Sarsfield',
  ],
  'Catamarca': [
    'San Fernando del Valle de Catamarca', 'Tinogasta', 'Belén', 'Andalgalá',
    'Santa María', 'Recreo', 'Chumbicha', 'Fiambalá', 'Londres',
    'Saujil', 'Pomán', 'Hualfín', 'San José', 'Icaño',
  ],
  'Chaco': [
    'Resistencia', 'Barranqueras', 'Fontana', 'Puerto Vilelas',
    'Presidencia Roque Sáenz Peña', 'Villa Ángela', 'Charata', 'General San Martín',
    'Las Breñas', 'Quitilipi', 'Machagai', 'Juan José Castelli',
    'General Pinedo', 'Presidencia de la Plaza', 'Corzuela', 'Hermoso Campo',
  ],
  'Chubut': [
    'Rawson', 'Trelew', 'Comodoro Rivadavia', 'Puerto Madryn', 'Esquel',
    'Sarmiento', 'Lago Puelo', 'El Hoyo', 'Gaiman', 'Dolavon',
    'El Bolsón', 'Rada Tilly', 'Gobernador Costa', 'Río Mayo', 'Paso de Indios',
  ],
  'Córdoba': [
    'Córdoba', 'Villa María', 'Río Cuarto', 'San Francisco', 'Villa Carlos Paz',
    'Alta Gracia', 'Río Tercero', 'Bell Ville', 'Jesús María', 'Cosquín',
    'La Falda', 'Villa Dolores', 'Marcos Juárez', 'Laboulaye', 'General Deheza',
    'Arroyito', 'Las Varillas', 'Oncativo', 'Villa Allende', 'Unquillo',
    'La Calera', 'Colonia Caroya', 'Villa del Rosario', 'Pilar', 'Río Ceballos',
    'Mina Clavero', 'Cruz del Eje', 'Dean Funes', 'Villa de Soto', 'Río Segundo',
    'Morteros', 'Porteña', 'Brinkmann', 'Oliva', 'Hernando',
    'Villa Nueva', 'Almafuerte', 'Villa General Belgrano', 'Santa Rosa de Calamuchita',
    'Embalse', 'Villa Rumipal', 'Los Cocos', 'La Cumbre', 'Capilla del Monte',
  ],
  'Corrientes': [
    'Corrientes', 'Goya', 'Paso de los Libres', 'Curuzú Cuatiá', 'Mercedes',
    'Monte Caseros', 'Bella Vista', 'Santo Tomé', 'Esquina', 'Ituzaingó',
    'Virasoro', 'Alvear', 'Empedrado', 'Saladas', 'San Luis del Palmar',
  ],
  'Entre Ríos': [
    'Paraná', 'Concordia', 'Gualeguaychú', 'Concepción del Uruguay', 'Villaguay',
    'Chajarí', 'Colón', 'Federación', 'Victoria', 'La Paz',
    'Nogoyá', 'Diamante', 'Federal', 'San José de Feliciano', 'Gualeguay',
    'Crespo', 'Seguí', 'Viale', 'Basavilbaso', 'Rosario del Tala',
  ],
  'Formosa': [
    'Formosa', 'Clorinda', 'Pirané', 'El Colorado', 'Ingeniero Juárez',
    'Las Lomitas', 'Ibarreta', 'Comandante Fontana', 'Laguna Blanca', 'Villafañe',
  ],
  'Jujuy': [
    'San Salvador de Jujuy', 'San Pedro de Jujuy', 'Palpalá', 'Libertador General San Martín',
    'Perico', 'El Carmen', 'Humahuaca', 'Tilcara', 'La Quiaca',
    'Abra Pampa', 'Monterrico', 'Fraile Pintado', 'Yuto', 'Calilegua',
  ],
  'La Pampa': [
    'Santa Rosa', 'General Pico', 'Toay', 'General Acha', 'Eduardo Castex',
    'Realicó', 'Intendente Alvear', 'Victorica', 'Macachín', '25 de Mayo',
    'Guatraché', 'Catriló', 'Ingeniero Luiggi', 'Quemú Quemú', 'Winifreda',
  ],
  'La Rioja': [
    'La Rioja', 'Chilecito', 'Aimogasta', 'Chamical', 'Chepes',
    'Villa Unión', 'Sanagasta', 'Nonogasta', 'Famatina', 'Patquía',
  ],
  'Mendoza': [
    'Mendoza', 'San Rafael', 'Godoy Cruz', 'Guaymallén', 'Las Heras',
    'Maipú', 'Luján de Cuyo', 'Tunuyán', 'San Martín', 'Rivadavia',
    'Junín', 'General Alvear', 'Malargüe', 'Tupungato', 'Lavalle',
    'Santa Rosa', 'La Paz', 'San Carlos', 'Palmira', 'Chacras de Coria',
  ],
  'Misiones': [
    'Posadas', 'Oberá', 'Eldorado', 'Puerto Iguazú', 'Apóstoles',
    'Jardín América', 'San Vicente', 'Leandro N. Alem', 'Montecarlo',
    'Puerto Rico', 'San Pedro', 'Aristóbulo del Valle', 'Wanda', 'Campo Grande',
    'Garuhapé', 'Puerto Esperanza', 'Candelaria', 'Garupá', 'San Javier',
  ],
  'Neuquén': [
    'Neuquén', 'San Martín de los Andes', 'Junín de los Andes', 'Zapala',
    'Centenario', 'Plottier', 'Cutral Có', 'Plaza Huincul', 'Chos Malal',
    'Rincón de los Sauces', 'Villa La Angostura', 'Senillosa', 'Villa El Chocón',
    'San Patricio del Chañar', 'Alumine',
  ],
  'Río Negro': [
    'Viedma', 'San Carlos de Bariloche', 'General Roca', 'Cipolletti', 'Allen',
    'Choele Choel', 'Villa Regina', 'El Bolsón', 'Sierra Grande', 'Las Grutas',
    'San Antonio Oeste', 'Cinco Saltos', 'Catriel', 'Ingeniero Huergo', 'Cervantes',
    'Fernández Oro', 'Mainqué', 'Lamarque', 'Luis Beltrán', 'Darwin',
  ],
  'Salta': [
    'Salta', 'San Ramón de la Nueva Orán', 'Tartagal', 'General Güemes',
    'Metán', 'Rosario de la Frontera', 'Cafayate', 'Joaquín V. González',
    'Embarcación', 'Aguaray', 'Salvador Mazza', 'San José de Metán',
    'General Mosconi', 'Pichanal', 'Cerrillos', 'Campo Quijano', 'San Lorenzo',
  ],
  'San Juan': [
    'San Juan', 'Rawson', 'Rivadavia', 'Chimbas', 'Santa Lucía',
    'Pocito', 'Caucete', 'San José de Jáchal', 'Albardón', 'Ullum',
    'Calingasta', 'Barreal', 'Iglesia', 'Valle Fértil', '25 de Mayo',
  ],
  'San Luis': [
    'San Luis', 'Villa Mercedes', 'Merlo', 'Juana Koslay', 'La Punta',
    'Justo Daract', 'Buena Esperanza', 'Concarán', 'Tilisarao', 'Naschel',
    'Quines', 'Candelaria', 'San Francisco del Monte de Oro', 'Luján',
  ],
  'Santa Cruz': [
    'Río Gallegos', 'Caleta Olivia', 'El Calafate', 'Pico Truncado',
    'Las Heras', 'Puerto Deseado', 'Puerto San Julián', 'Perito Moreno',
    'Gobernador Gregores', 'El Chaltén', 'Comandante Luis Piedra Buena', 'Los Antiguos',
    '28 de Noviembre', 'Río Turbio',
  ],
  'Santa Fe': [
    'Santa Fe', 'Rosario', 'Rafaela', 'Venado Tuerto', 'Reconquista',
    'Villa Gobernador Gálvez', 'Casilda', 'San Lorenzo', 'Esperanza',
    'Sunchales', 'Cañada de Gómez', 'Firmat', 'Rufino', 'Tostado',
    'Villa Constitución', 'San Jorge', 'San Justo', 'Vera', 'Avellaneda',
    'Arroyo Seco', 'Funes', 'Roldán', 'Capitán Bermúdez', 'Granadero Baigorria',
    'Pérez', 'Zavalla', 'Santo Tomé', 'Sauce Viejo', 'Recreo',
    'San Cristóbal', 'Gálvez', 'Coronda', 'Las Rosas', 'Armstrong',
    'Totoras', 'Carcarañá', 'San Genaro', 'Alcorta', 'Bigand',
  ],
  'Santiago del Estero': [
    'Santiago del Estero', 'La Banda', 'Termas de Río Hondo', 'Añatuya',
    'Frías', 'Fernández', 'Quimilí', 'Monte Quemado', 'Suncho Corral',
    'Loreto', 'Campo Gallo', 'Bandera', 'Selva', 'Villa Ojo de Agua',
    'Nueva Esperanza', 'Clodomira',
  ],
  'Tierra del Fuego': [
    'Ushuaia', 'Río Grande', 'Tolhuin',
  ],
  'Tucumán': [
    'San Miguel de Tucumán', 'Yerba Buena', 'Tafí Viejo', 'Banda del Río Salí',
    'Concepción', 'Monteros', 'Famaillá', 'Aguilares', 'Juan Bautista Alberdi',
    'Simoca', 'Lules', 'Tafí del Valle', 'Trancas', 'Burruyacú',
    'Bella Vista', 'La Cocha', 'Graneros', 'El Manantial', 'Las Talitas',
    'San Pablo', 'Alderetes',
  ],
};

// Obtener todas las ciudades (para cuando no hay provincia seleccionada)
export const TODAS_LAS_CIUDADES = Object.values(CIUDADES_POR_PROVINCIA).flat().sort();
